export default __webpack_public_path__ + "static/media/Intermedio.ec9e7c78.jpg";